






























import { Component, Prop } from 'vue-property-decorator'

import { SampleNodeMixin } from '../../../../index'
import { CreateLimitedSubscriptionNode } from '../../logic/CreateLimitedSubscription'

@Component
export default class CreateLimitedSubscriptionSampleNode extends SampleNodeMixin {
  @Prop() node!: CreateLimitedSubscriptionNode

  get channelTitle(): string | undefined {
    const target = this.node.nodeProps.targets()
      .find((t) => t.id === this.node.data.target)

    if (target) {
      return target.title
    }

    return undefined
  }
}
